import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../custom.css';
import * as AppConstants from '../AppConstants';
import {
  FilePlus,
  Edit3,
  UserPlus,
  Users,
  Search,
  Zap,
  Clock,
  Bell,
} from 'react-feather';

export function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="container px-0 px-lg-2">
      <div className="row">
        <div className="col-12 col-lg-4 mb-3">
          <div className="home-card h-100">
            <div className="home-card-hero">
              <div className="home-card-title">
                <span className="home-card-icon">
                  <FilePlus size={16} />
                </span>
                Property Listings
              </div>
              <p className="home-subtitle">
                Create a fresh listing or resume a draft.
              </p>
            </div>
            <div className="home-card-body">
              <div className="home-actions">
                <Link to="/Inspectionform" className="home-action-btn">
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <FilePlus size={16} />
                    </span>
                    New Property Listing
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
                <Link to="/MyDraftListings" className="home-action-btn">
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <Edit3 size={16} />
                    </span>
                    My Draft Listings
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-4 mb-3">
          <div className="home-card h-100">
            <div className="home-card-hero">
              <div className="home-card-title">
                <span className="home-card-icon">
                  <Users size={16} />
                </span>
                Clients
              </div>
              <p className="home-subtitle">
                Register new clients or review your list.
              </p>
            </div>
            <div className="home-card-body">
              <div className="home-actions">
                <Link to="/RegisterAClient" className="home-action-btn">
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <UserPlus size={16} />
                    </span>
                    Register New Client
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
                <Link to="/MyClients" className="home-action-btn">
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <Users size={16} />
                    </span>
                    My Clients
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>

        <div className="col-12 col-lg-4 mb-3">
          <div className="home-card h-100">
            <div className="home-card-hero">
              <div className="home-card-title">
                <span className="home-card-icon">
                  <Search size={16} />
                </span>
                Properties
              </div>
              <p className="home-subtitle">
                Search, spot hot properties, or see the latest.
              </p>
            </div>
            <div className="home-card-body">
              <div className="home-actions">
                <Link to="/PropertySearch" className="home-action-btn">
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <Search size={16} />
                    </span>
                    Property Search
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
                <Link to="/HotProperties" className="home-action-btn">
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <Zap size={16} />
                    </span>
                    Hot Properties
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
                <Link
                  to="/PropertyRecentListings"
                  className="home-action-btn"
                >
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <Clock size={16} />
                    </span>
                    Recent Listings
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
                <Link to="/Tasks" className="home-action-btn">
                  <span className="home-action-left">
                    <span className="home-action-icon">
                      <Bell size={16} />
                    </span>
                    Tasks
                  </span>
                  <span className="home-action-chevron">{'>'}</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex flex-row justify-content-between align-items-center mt-2">
        <small className="text-muted">
          {AppConstants.BUILD_NUMBER}
        </small>
        <small className="text-muted">
          {AppConstants.BUILD_DATE}
        </small>
      </div>
    </div>
  );
}
